module.exports = __webpack_public_path__ + "img/CM-MS-CA-23-Toyota-Playful.24eda308.jpeg";